<app-question-base
  [question]="matrixQuestion"
  [isFirstQuestion]="isFirstQuestion"
  [isMatrixQuestion]="true"
  [mandatoryValue]="
    matrixQuestion.rows[0] ? matrixQuestion.rows[0].mandatory : false
  "
>
  @if (matrixQuestion.rows.length > 0) {
    @if (matrixQuestion.rows[0].type === "SINGLE_CHOICE") {
      <app-matrix-single-select
        [matrixQuestion]="matrixQuestion"
        [form]="form"
        class="block w-full min-w-0"
      >
      </app-matrix-single-select>
    } @else if (matrixQuestion.rows[0].type === "MULTIPLE_CHOICE") {
      <app-matrix-multi-select
        [matrixQuestion]="matrixQuestion"
        [form]="form"
        class="block w-full min-w-0"
      >
      </app-matrix-multi-select>
    } @else {
      @for (question of matrixQuestion.rows; track $index) {
        @if (question.type === "OPENANSWER") {
          <div class="mx-auto">
            <app-open-answer
              [inMatrix]="true"
              [control]="form.get(question.id)!"
              [question]="question"
            ></app-open-answer>
          </div>
        }
      }
    }
  }
</app-question-base>
